import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RealPipe } from './real';
import { PadStartPipe } from './pad-start';
import { ReplaceAllPipe } from './replace-all';
import { TipoEmpresaPipe } from './tipo-empresa';
import { TipoUsuarioPipe } from './tipo-usuario';
import { AcaoLogGeralPipe } from './acao-log-geral';
import { StatusLogGeralPipe } from './status-log-geral';
import { CapitalizeWordsPipe } from './capitalize-words';
import { SegmentoProdutoPipe } from './segmento-produto';
import { SexoBeneficiarioPipe } from './sexo-beneficiario';
import { TipoBeneficiarioPipe } from './tipo-beneficiario';
import { TipoMovimentacaoPipe } from './tipo-movimentacao';
import { SegmentoContratoPipe } from './segmento-contrato';
import { BadgeTipoEmpresaPipe } from './badge-tipo-empresa';
import { StatusMovimentacaoPipe } from './status-movimentacao';
import { StatusFilaIntegracaoPipe } from './status-fila-integracao';
import { TipoVariacaoPipe } from './segmento-produto/tipo-variacao';
import { BadgeTipoMovimentacaoPipe } from './badge-tipo-movimentacao';
import { TipoSignificadoRubricaPipe } from './tipo-significado-rubrica';
import { BadgeStatusMovimentacaoPipe } from './badge-status-movimentacao';
import { StatusProdutoBeneficiarioPipe } from './status-produto-beneficiario';
import { StatusDetalheMovimentacaoPipe } from './status-detalhe-movimentacao';
import { BadgeStatusFilaIntegracaoPipe } from './badge-status-fila-integracao';
import { StatusPainelDeAtendimentoPipe } from './status-painel-de-atendimento';
import { StatusCabecalhoPedidoCargaPipe } from './status-cabecalho-pedido-carga';
import { StatusIntegracaoOrquestradorPipe } from './status-integracao-orquestrador';
import { BadgeStatusProdutoBeneficiarioPipe } from './badge-status-produto-beneficiario';
import { BadgeStatusPainelDeAtendimentoPipe } from './badge-status-painel-de-atendimento';
import { StatusDetalheConferenciaDeFaturaPipe } from './status-detalhe-conferencia-de-fatura';
import { BadgeStatusCabecalhoPedidoDeCargaPipe } from './badge-status-cabecalho-pedido-de-carga';
import { StatusCabecalhoConferenciaDeFaturaPipe } from './status-cabecalho-conferencia-de-fatura';
import { BadgeStatusDetalheConferenciaDeFaturaPipe } from './badge-status-detalhe-conferencia-de-fatura';
import { BadgeStatusCabecalhoConferenciaDeFaturaPipe } from './badge-status-cabecalho-conferencia-de-fatura';
import { CodigoCriticaDetalheConferenciaFaturaPipe } from './codigo-critica-detalhe-conferencia-fatura';
import { StatusMovimentacaoCadastralManualPipe } from './status-movimentacao-cadastral-manual';
import { BadgeStatusMovimentacaoCadastralManualPipe } from './badge-status-movimentacao-cadastral-manual';

const pipes = [
  RealPipe,
  PadStartPipe,
  ReplaceAllPipe,
  TipoEmpresaPipe,
  TipoUsuarioPipe,
  TipoVariacaoPipe,
  AcaoLogGeralPipe,
  StatusLogGeralPipe,
  SegmentoProdutoPipe,
  CapitalizeWordsPipe,
  BadgeTipoEmpresaPipe,
  SegmentoContratoPipe,
  TipoBeneficiarioPipe,
  TipoMovimentacaoPipe,
  SexoBeneficiarioPipe,
  StatusMovimentacaoPipe,
  StatusFilaIntegracaoPipe,
  BadgeTipoMovimentacaoPipe,
  TipoSignificadoRubricaPipe,
  BadgeStatusMovimentacaoPipe,
  StatusDetalheMovimentacaoPipe,
  StatusPainelDeAtendimentoPipe,
  StatusProdutoBeneficiarioPipe,
  BadgeStatusFilaIntegracaoPipe,
  StatusPainelDeAtendimentoPipe,
  StatusCabecalhoPedidoCargaPipe,
  StatusIntegracaoOrquestradorPipe,
  BadgeStatusPainelDeAtendimentoPipe,
  BadgeStatusProdutoBeneficiarioPipe,
  StatusDetalheConferenciaDeFaturaPipe,
  StatusMovimentacaoCadastralManualPipe,
  BadgeStatusCabecalhoPedidoDeCargaPipe,
  StatusCabecalhoConferenciaDeFaturaPipe,
  CodigoCriticaDetalheConferenciaFaturaPipe,
  BadgeStatusDetalheConferenciaDeFaturaPipe,
  BadgeStatusMovimentacaoCadastralManualPipe,
  BadgeStatusCabecalhoConferenciaDeFaturaPipe,
];

@NgModule({
  declarations: [...pipes],
  imports: [CommonModule],
  exports: [...pipes],
})
export class PipesModule {}
